import { createStyles, Theme } from "@material-ui/core";
import Constants from "../models/utility/Constants";

// column widths for live (100%)
const parcelImage = 20;
const timeLeftLive = 22;
const bidAmountLive = 28;
const bidButtonLive = 25;

// column widths for not live (100%)
const parcelImageNotLive = 20;
const timeLeftNotLive = 27.5;
const bidAmountNotLive = 20;
const bidAmountCompleted = 47.5;
const viewPurchaseAgreementNotLive = 25;

// column widths for mobile live (300%, flex-wrap 3 lines)
const mobileParcelImage = 100;
const mobileTimeLeft = 33;
const mobileBidAmount = 33;
const mobileBidButton = 100;

export const styles = (theme: Theme) =>
    createStyles({
        columnBidAmountLive: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileBidAmount}%`,
                paddingLeft: 0
            },
            flexBasis: `${bidAmountLive}%`,
            paddingLeft: theme.spacing(1.5)
        },
        columnBidAmountNotLive: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileBidAmount}%`,
                paddingLeft: 0,
                paddingRight: "0 !important"
            },
            flexBasis: `${bidAmountNotLive}%`,
            paddingLeft: theme.spacing(1.5)
        },
        columnBidAmountCompleted: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `63%`,
                paddingLeft: 0,
                paddingRight: "0 !important"
            },
            flexBasis: `${bidAmountCompleted}%`,
            paddingLeft: theme.spacing(1.5)
        },
        columnBidButtonLive: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileBidButton}%`,
                paddingLeft: 0,
                paddingRight: "0 !important",
                paddingTop: theme.spacing(3),
                textAlign: "center",
                display: "block"
            },
            flexBasis: `${bidButtonLive}%`,
            display: "flex",
            justifyContent: "flex-end"
        },

        columnParcelImageLive: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileParcelImage}%`
            },
            flexBasis: `${parcelImage}%`
        },
        columnParcelImageNotLive: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileParcelImage}%`
            },
            flexBasis: `${parcelImageNotLive}%`
        },
        columnParcelImageWidth: {
            [theme.breakpoints.down("sm")]: { width: `${mobileParcelImage}%` },
            width: `${parcelImage}%`
        },
        columnFirst: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileTimeLeft}%`,
                paddingLeft: theme.spacing(1),
                paddingRight: Constants.IsIE ? 0 : theme.spacing()
            },
            flexBasis: `${timeLeftLive}%`,
            paddingLeft: theme.spacing(2)
        },
        columnSecond: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: `${mobileTimeLeft}%`,
                paddingLeft: 0,
                paddingRight: Constants.IsIE ? 0 : theme.spacing()
            },
            flexBasis: `${timeLeftNotLive}%`
        },
        columnLast: {
            [theme.breakpoints.down("sm")]: { paddingRight: 0 },
            paddingRight: theme.spacing(2)
        },
        tabSection: {
            [theme.breakpoints.down("sm")]: {
                flexBasis: "100%",
                paddingLeft: 0
            },
            flexBasis: "100%",
            paddingRight: "0 !important",
            display: "flex"
        },
        tabSectionOffset: {
            [theme.breakpoints.down("sm")]: { flexBasis: "0%" },
            flexBasis: `${parcelImage}%`
        },
        columnViewOfferToPurchaseCTA: {
            flexBasis: `${viewPurchaseAgreementNotLive}%`,
            display: "flex",
            justifyContent: "flex-end",

            [theme.breakpoints.down("sm")]: {
                flexBasis: `100%`,
                justifyContent: "center",
                padding: theme.spacing(3)
            }
        }
    });
